import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

// Componente de estatísticas animadas
const StatCard = ({ number, label, suffix = '', delay = 0, useLocaleString = true }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    if (isVisible) {
      const duration = 2000;
      const increment = number / (duration / 16);
      let current = 0;
      
      const timer = setInterval(() => {
        current += increment;
        if (current >= number) {
          setCount(number);
          clearInterval(timer);
        } else {
          setCount(Math.floor(current));
        }
      }, 16);

      return () => clearInterval(timer);
    }
  }, [isVisible, number]);

  return (
    <div className={`text-center transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
      <div className="text-4xl font-bold text-white mb-2">
        {useLocaleString ? count.toLocaleString() : count}{suffix}
      </div>
      <div className="text-white/80 text-sm font-medium">
        {label}
      </div>
    </div>
  );
};

// Componente principal da HomePage
const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-primary via-primary-dark to-primary">
      <Header />
      
      {/* Hero Section */}
      <main className="flex-grow relative">
        {/* Background Patterns */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 right-0 w-64 h-64 rounded-full bg-white/3 transform translate-x-32"></div>
          <div className="absolute bottom-0 left-1/3 w-80 h-80 rounded-full bg-white/4 transform translate-y-40"></div>
        </div>

        <div className="relative container mx-auto px-4 py-16">
          {/* Header Section */}
          <div className={`text-center mb-20 transform transition-all duration-1000 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
            {/* Logo da Cooperativa - Centralizada e em destaque */}
            <div className="flex justify-center mb-12">
              <div className="relative group">
                <img 
                  src="/images/coopdelta.png" 
                  alt="Logo COOPDELTA" 
                  className="w-56 h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 object-contain transition-all duration-500 group-hover:scale-105 drop-shadow-2xl"
                />
                
                {/* Efeito de brilho sutil atrás da logo */}
                <div className="absolute inset-0 w-56 h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 bg-white/5 rounded-full blur-3xl -z-10 group-hover:bg-white/10 transition-all duration-500"></div>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="grid grid-cols-3 gap-8 mb-16 max-w-2xl mx-auto">
            <StatCard number={50} label="Cooperados" suffix="+" delay={500} />
            <StatCard number={15} label="Famílias Atendidas" suffix="+" delay={700} />
            <StatCard number={2018} label="Fundada em" delay={900} useLocaleString={false} />
          </div>



          {/* Call to Action Section */}
          <div className={`text-center mt-20 transform transition-all duration-1000 delay-1000 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 max-w-4xl mx-auto border border-white/20">
              <h2 className="text-3xl font-bold text-white mb-4">
                Preservando Tradições, Inovando o Futuro
              </h2>
              <p className="text-white/80 text-lg mb-6 max-w-2xl mx-auto">
                A COOPDELTA utiliza tecnologia para fortalecer a comunidade tradicional, 
                garantindo a sustentabilidade dos recursos naturais e a qualidade de vida das famílias.
              </p>
              
              <div className="flex flex-wrap justify-center gap-4">
                <Link 
                  to="/contratos/novo" 
                  className="bg-white text-primary px-8 py-3 rounded-full font-semibold hover:bg-white/90 transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  Criar Contrato
                </Link>
                <Link 
                  to="/agua" 
                  className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-primary transition-all duration-300 transform hover:scale-105"
                >
                  Ver Qualidade da Água
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default HomePage;